<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-truncation`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 5a1 1 0 011-1h2a1 1 0 011 1v38a1 1 0 01-1 1H7a1 1 0 01-1-1V5zm14 18a1 1 0 011-1h17V5a1 1 0 011-1h2a1 1 0 011 1v38a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H21a1 1 0 01-1-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconTruncation',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
